import { React, useState, useEffect, useContext } from "react";
import "./ProjectGrid.scss";
import {
    BrowserRouter as Router,
    useOutletContext,
    Link,
} from "react-router-dom";
import db from "../../../api/mongodb";
import ProjectGridList from "./ProjectGridList";
import { defaultOptions1 } from "../../../config/loading-config.js";
import Lottie from "react-lottie";
import { safeAP_id } from "../../../api/testData";
import { Image } from "react-bootstrap";

import Nav from "react-bootstrap/Nav";
import HomeIcon from "../../../images/Home.svg";
import ProjectsIcon from "../../../images/Projects.svg";
import SafeApsIcon from "../../../images/SafeAps.svg";
import ClientsIcon from "../../../images/Clients.svg";
import GridViewIcon from "../../../images/grid-view.svg";
import ListViewIcon from "../../../images/list-view.svg";
import SearchIcon from "../../../images/Search.svg";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InputGroup from "react-bootstrap/InputGroup";
import { UserDispatchContext, UserContext } from "./../../../api/UserProvider";
import Pagination from "../../../utils/helpers/components/Pagination";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";



const ProjectGrid = ({ projectStatus }) => {
    const [isLoading, setIsLoading] = useState(true);
    const details = useContext(UserContext);
    const setDetails = useContext(UserDispatchContext);
    const [selectedTab, setSelectedTab] = useState(projectStatus??"active");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsCount, setItemsCount] = useState(0);
    const [status, setStatus] = useState(projectStatus??"active");
    const [bestPracticeAuthorized, setBestPracticeAuthorized] = useState(false)
    const [search, setSearch] = useState("");



    const itemsPerPage = 6;

    const projectQuery = useQuery({
        queryKey: ["projects",status, currentPage,itemsPerPage ,search],
        queryFn: async () => {
            const response = await db.get(
                `/api/projects/find/multiple?page=${currentPage}&limit=${itemsPerPage}&status=${status}&searchField=${search}`,
            );
            return response.data;
        },
    })

    useEffect(() => {
        setCurrentPage(1);
    }, [search]);

    useEffect(() => {
        setCurrentPage(1);
    }, [status]);


    useEffect(() => {
        if (projectQuery.status === "success") {
            setFilteredProjects(projectQuery.data.data);
            setItemsCount(projectQuery.data.metadata.totalCount);
        }
    
    }, [projectQuery.status, projectQuery.isFetching]);

    const {
        projects,
        setProjects,
        filteredProjects,
        setFilteredProjects,
        safeAp,
        safeApId,
        // isLoading,
        setSafeAp,
        // setIsLoading,
    } = useOutletContext();


    useEffect(() => {
        db.get("/api/bestPractices/authorized")
            .then((data) => {
                setBestPracticeAuthorized(true)
            })
            .catch((err) => {
                setBestPracticeAuthorized(false)
            })
    }, [bestPracticeAuthorized])

    
   

    return (
        <>
            <div className="project-grid">
                <div className="project-grid-header">
                    <Grid container columnSpacing={2}>
                        <Grid item sx={{ flexGrow: 1 }}>
                            <h1 className="page-title">Projects</h1>
                        </Grid>
                        {
                            bestPracticeAuthorized &&
                            <>
                                <Grid item>
                                    <Link to="/bestPracticeList">
                                        <Button className="btn-primary">View Best Practices</Button>
                                    </Link>
                                </Grid>

                                <Grid item>
                                    <Link to="/createBestPractice">
                                        <Button className="btn-primary">Create Best Practice</Button>
                                    </Link>
                                </Grid>
                            </>
                        }


                        <Grid item >
                            <Link to="/projects/new">
                                <Button className="btn-primary">Create New Project</Button>
                            </Link>
                        </Grid>

                    </Grid>



                    {/* <Link to="/projects/new">
                        <Button className="btn-primary">Create New Project</Button>
                    </Link> */}
                </div>

                <div className="project-grid-header">
                    <div className="search-filter">
                        <InputGroup>
                            <Form.Label htmlFor="searchProjects" hidden>
                                Search Projects
                            </Form.Label>
                            <InputGroup.Text>
                                <img src={SearchIcon} alt="" />
                            </InputGroup.Text>
                            <Form.Control
                                type="text"
                                id="input"
                                placeholder="Search projects..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                aria-describedby="searchProjects"
                            />
                        </InputGroup>
                    </div>
                    <div className="grid-list-icons">
                        {/* <img src={GridViewIcon} alt="Grid view icon" />
            <img src={ListViewIcon} alt="Grid list icon" /> */}
                    </div>
                </div>

                <div className="projects-menu-tab">
                    <span
                        onClick={() => {
                            setSelectedTab("active");
                            setStatus("active");
                        }}
                    >
                        <Link
                            to="/projects/active"
                            className={projectStatus === "active" ? "active" : ""}
                        >
                            Active
                        </Link>
                    </span>
                    <span
                        onClick={() => {
                            setSelectedTab("completed");
                            setStatus("completed");
                        }}
                    >
                        <Link
                            to="/projects/completed"
                            className={projectStatus === "completed" ? "active" : ""}
                        >
                            Completed
                        </Link>
                    </span>
                    <hr />
                </div>

                <div className="project-list">
                    <Row>
                        <ProjectGridList
                            safeApId={safeApId}
                            projects={filteredProjects}
                            // search={false}
                            projectType={projectStatus}
                            isLoading={projectQuery.isPending}
                        />
                        <Pagination
                            itemsCount={itemsCount}
                            itemsPerPage={itemsPerPage}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            alwaysShown={true}
                            isLoading={projectQuery.isPending}
                        />
                    </Row>
                </div>
            </div>
        </>
    );
};

export default ProjectGrid;
